// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qPwX","footer":"styles_footer__1NOU8","passCodeTooltip":"styles_passCodeTooltip__2MGV3"};